import React from "react";
import { Link as RouterLink } from "react-router";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import SvgIcon from "@mui/material/SvgIcon";
import { PlusCircle as PlusCircleIcon } from "react-feather";
import { usePermissions } from "src/contexts/permissions";
import SearchField from "./SearchField";

const styles = {
  action: {
    mb: 1,
    "& + &": {
      ml: 1,
    },
  },
};

const Header = ({ configuration }) => {
  const { can } = usePermissions();
  const canWrite = configuration.accessKey ? can(`${configuration.accessKey}.write`) : true;

  return (
    <Grid container spacing={1}>
      {configuration.title && (
        <Grid size={6}>
          <Box mb={3}>
            <Typography variant="h2" color="textSecondary">
              {configuration.title}
            </Typography>
          </Box>
        </Grid>
      )}
      <Grid size={6}>
        <Grid container spacing={2} justifyContent="flex-end" alignItems="center">
          {configuration.newLink && configuration.newLink.path && canWrite && (
            <Grid>
              <Button
                id={`newLink-${configuration.key}`}
                color="primary"
                variant="contained"
                component={RouterLink}
                to={configuration.newLink.path()}
                sx={styles.action}
                startIcon={
                  <SvgIcon fontSize="small">
                    <PlusCircleIcon />
                  </SvgIcon>
                }
              >
                {configuration.newLink.title || "New Record"}
              </Button>
            </Grid>
          )}
          {configuration.newLink && configuration.newLink.onClick && canWrite && (
            <Grid>
              <Button
                id={`newButton-${configuration.key}`}
                color="primary"
                variant="contained"
                onClick={configuration.newLink.onClick}
                sx={styles.action}
                startIcon={
                  <SvgIcon fontSize="small">
                    <PlusCircleIcon />
                  </SvgIcon>
                }
              >
                {configuration.newLink.title || "New Record"}
              </Button>
            </Grid>
          )}
          {configuration.customActionComponent && (
            <Grid>
              <configuration.customActionComponent sx={styles.action} />
            </Grid>
          )}
          {configuration.searchConfig && (
            <Grid>
              <SearchField
                onSearch={configuration.searchConfig.onSearch}
                placeholder={configuration.searchConfig.placeholder}
                initialValue={configuration.searchConfig.initialValue}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Header;
